// extracted by mini-css-extract-plugin
module.exports = {"label":"CustomPricePointTab_label__38x2-","text":"CustomPricePointTab_text__2LoSZ","input":"CustomPricePointTab_input__2ohJ-","button":"CustomPricePointTab_button__1H-6_"};